function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.67.5a.5.5 0 0 0-.771-.42 4.88 4.88 0 0 0-2.23 4.353v2.648a1.66 1.66 0 0 0 .955 1.538l.005.003c.182.083.543.208.83.304L11.68 9h-.844a.5.5 0 0 0-.5.5v5.333A1.167 1.167 0 0 0 11.503 16h.667a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.25-.433.502.502 0 0 0 .25-.434V.5zm-1 1.074v6.368a9.102 9.102 0 0 1-.623-.229.66.66 0 0 1-.377-.613V4.393a3.88 3.88 0 0 1 1-2.819zm0 8.426v5h-.167a.167.167 0 0 1-.167-.167V10h.334zM4.33 1.833a.5.5 0 0 0-1 0v4A1.833 1.833 0 0 0 4.997 7.66V9H4.83a.5.5 0 0 0-.5.5v5.333a1.167 1.167 0 1 0 2.333 0V9.5a.5.5 0 0 0-.5-.5h-.166V7.66a1.833 1.833 0 0 0 1.666-1.827v-4a.5.5 0 0 0-1 0v4a.833.833 0 0 1-.833.834h-.667a.833.833 0 0 1-.833-.834v-4zm1.167-.5a.5.5 0 0 1 .5.5v3.368a.5.5 0 1 1-1 0V1.833a.5.5 0 0 1 .5-.5zm-.167 13.5V10h.333v4.833a.167.167 0 0 1-.333 0z",
  fill: "#004152"
});

var SvgRestaurant = function SvgRestaurant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRestaurant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/restaurant.fb0afd99.svg";
export { ForwardRef as ReactComponent };